import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appNotificationScroll]'
})
export class NotificationScrollDirective {

  public pageNumber: number = 1;
  public isLoading: boolean = false;
  @Output('onPageChange') onPageChange: EventEmitter<number> = new EventEmitter();

  @Input('setToTop')
  set setToTop(value) {
    if (this.el && this.el.nativeElement) {
      this.el.nativeElement.scrollTop = 0;
    }
    this.pageNumber = 1;
    this.isLoading = false;
  }

  constructor(private el: ElementRef) {
  }

  @HostListener('scroll')
  onScroll() {
    const el = this.el.nativeElement;
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= 40) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.pageNumber++;
        this.onPageChange.emit(this.pageNumber);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      }
    }
  }

}
